import React, { Component } from "react";
import queryString from "query-string";

import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import { formatNumber, formatCurrency } from "../../utils/helpers";
import dayjs from "dayjs";
import Loader from "../general/Loader";

export default class ReporteProduccionEmpleados extends Component {
    state = {
        empleados: false,
    };
    componentDidMount() {
        this.getReporte();
    }
    getReporte = async () => {
        const token = auth.getToken();

        const res = await fetch(apiUrl(`reportes` + window.location.search), {
            method: "get",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.setState({
                empleados: response.data,
            });
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    render() {
        const { empleados } = this.state;

        if (!empleados) {
            return <Loader />;
        }

        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];
        const query = queryString.parse(window.location.search);

        return (
            <div>
                <div className='row'>
                    <h2 className='col-md-12 text-center m-b-5'>
                        Detalle de Producción Empleados
                    </h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {dayjs(query.desde).format("DD/MM/YYYY")} -{" "}
                        {dayjs(query.hasta).format("DD/MM/YYYY")}
                    </div>
                    <div className='col-md-12 p-b-10'></div>
                    <div className='col-md-12 text-right p-b-10'>
                        <div className='float-left'>
                            Empleados: {Object.keys(empleados).length}
                        </div>

                        <div className='float-right'></div>
                    </div>
                </div>
                {Object.keys(empleados).map((empleado, index) => {
                    let totalToneladas = 0;
                    let totalSueldo = 0;
                    let totalViajes = 0;
                    const otrosDesc = empleados[empleado].descuentos.reduce(
                        (acc, desc) => acc + parseFloat(desc.monto),
                        0
                    );
                    return (
                        <div>
                            <h3>
                                {empleados[empleado].codigo} -{" "}
                                {empleados[empleado].nombre}{" "}
                                {empleados[empleado].apellido} (
                                {empleados[empleado].cargo})
                            </h3>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Ficha</th>
                                        <th>Categoría</th>
                                        <th>Función</th>
                                        <th>Ruta</th>
                                        <th className='text-center'>Viajes</th>
                                        <th className='text-center'>Sueldo</th>
                                        <th className='text-center'>
                                            Toneladas
                                        </th>
                                        <th className='text-right'>Pago</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.keys(empleados[empleado].tarjetas)
                                        .sort((a, b) => {
                                            return (
                                                dayjs(
                                                    empleados[empleado]
                                                        .tarjetas[a].fecha
                                                ).unix() -
                                                dayjs(
                                                    empleados[empleado]
                                                        .tarjetas[b].fecha
                                                ).unix()
                                            );
                                        })
                                        .map((id, index) => {
                                            const tarjeta =
                                                empleados[empleado].tarjetas[
                                                    id
                                                ];
                                            const toneladas =
                                                tarjeta.tickets.reduce(
                                                    (acc, ticket) => {
                                                        if (ticket.soloChofer && tarjeta.funcion.indexOf('Chofer') === -1 ) {
                                                            return acc;
                                                        }
                                                        return (
                                                            acc +
                                                            parseFloat(
                                                                ticket.pesoNeto
                                                            )
                                                        );
                                                    },
                                                    0
                                                ) / 1000;
                                            const viajes = tarjeta.tickets.filter(
                                                ticket => !(ticket.soloChofer && tarjeta.funcion.indexOf('Chofer') === -1)
                                            ).length;
                                            totalToneladas += toneladas;
                                            totalSueldo +=
                                                tarjeta.sueldo * toneladas;
                                            totalViajes += viajes;
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {dayjs(
                                                            tarjeta.fecha
                                                        ).format("DD/MM/YYYY")}
                                                    </td>
                                                    <td>{tarjeta.ficha}</td>
                                                    <td>{tarjeta.categoria}</td>
                                                    <td>{tarjeta.funcion}</td>
                                                    <td>{tarjeta.ruta}</td>
                                                    <td className='text-center'>
                                                        {viajes}
                                                    </td>
                                                    <td className='text-center'>
                                                        {formatCurrency(
                                                            tarjeta.sueldo
                                                        )}
                                                    </td>
                                                    <td className='text-center'>
                                                        {" "}
                                                        {formatNumber(
                                                            toneladas
                                                        )}
                                                    </td>
                                                    <td className='text-right'>
                                                        {formatCurrency(
                                                            tarjeta.sueldo *
                                                                toneladas
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td className='text-center'>
                                            {totalViajes}
                                        </td>
                                        <td></td>
                                        <td className='text-center'>
                                            {formatNumber(totalToneladas)}
                                        </td>
                                        <td className='text-right'>
                                            <div>
                                                {formatCurrency(totalSueldo)}
                                            </div>
                                            {!empleados[empleado].informal && (
                                                <div>
                                                    TSS:{" "}
                                                    {formatCurrency(
                                                        empleados[empleado]
                                                            .descuentoFijo
                                                    )}
                                                </div>
                                            )}
                                            {otrosDesc > 0 && (
                                                <div>
                                                    Otros Descuentos:{" "}
                                                    {formatCurrency(otrosDesc)}
                                                </div>
                                            )}
                                            {empleados[empleado].informal ? (
                                                <div>
                                                    <strong>
                                                        TOTAL:{" "}
                                                        {formatCurrency(
                                                            totalSueldo -
                                                                otrosDesc
                                                        )}
                                                    </strong>
                                                </div>
                                            ) : (
                                                <div>
                                                    <strong>
                                                        TOTAL:{" "}
                                                        {formatCurrency(
                                                            totalSueldo -
                                                                otrosDesc -
                                                                empleados[
                                                                    empleado
                                                                ].descuentoFijo
                                                        )}
                                                    </strong>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                })}
            </div>
        );
    }
}
